/**
 * @typedef {object} PortfolioRow
 * @property {'group'|'child'} kind - Kopregel van een portfolio, of een project eronder
 * @property {{CommunityName?: string}} [portfolio] - Het portfolio waar deze rij bij hoort
 * @property {Array<{CommunityName?: string}>} [children] - De projecten onder een kopregel
 * @property {{CommunityName?: string}} [item] - Het project zelf, bij een kindrij
 */

/**
 * De tekst waarop de zoekbalk van het portfolio-overzicht een rij vindt.
 *
 * De gegroepeerde tabel heeft twee soorten rijen, en zoeken op alleen de eigen
 * naam laat allebei de kanten stuk:
 * - een kopregel die alleen zijn eigen naam draagt verdwijnt zodra je een
 *   project zoekt, en dan staat dat project onder een portfolio dat niet meer
 *   in beeld is;
 * - een projectrij die alleen zijn eigen naam draagt verdwijnt zodra je de
 *   portfolionaam intypt, en dan zie je een kopregel zonder inhoud.
 *
 * Daarom draagt elke rij de namen van beide kanten mee.
 *
 * @param {PortfolioRow|null|undefined} row - Een rij uit `portfolioTableItems`
 * @returns {string} De doorzoekbare tekst; leeg als er geen naam bekend is
 */
const portfolioRowSearchText = (row) => {
    if (!row) return ''

    const names = row.kind === 'group'
        ? [row.portfolio?.CommunityName, ...(row.children || []).map((child) => child?.CommunityName)]
        : [row.item?.CommunityName, row.portfolio?.CommunityName]

    return names.filter(Boolean).join(' ')
}

export default portfolioRowSearchText
